<template>
    <v-card height="326" elevation="0" style="border-radius: 10px">
        <v-card-text style="box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7)">
            <v-form ref="formQualified">
                <v-row no-gutters>
                    <v-col cols="12" lg="12" class="d-flex column align-center">
                        <v-avatar
                            color="#255d98"
                            size="27"
                            class="d-flex align-center avatar-shadow"
                        >
                            <span
                                class="white--text prompt-title-page"
                                style="font-size: 18px"
                                >1</span
                            >
                        </v-avatar>
                        <div class="my-1 prompt-title ml-3">
                            {{ $t('message.qualifiedApplicants.stepHeader.one') }}
                        </div>
                    </v-col>
                    <v-col cols="6" lg="6" style="width: 299px">
                        <v-row>
                            <v-col cols="11" md="11">
                                <div class="pa-1 form-label">
                                    {{ $t('message.qualifiedApplicants.ListAcademicYear') }}
                                    <strong>*</strong>
                                </div>
                                <v-select
                                    v-model="selectedRegisterForm"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    :placeholder="`- ${$t('message.qualifiedApplicants.selectRound')} -`"
                                    :items="rounds"
                                    item-text="name"
                                    item-value="id"
                                    :rules="[
                                        (v) =>
                                            !!v ||
                                            'message.qualifiedApplicants.error.selectListApplicantAcademic',
                                    ]"
                                    required
                                ><template #message="{ message }">
                                    {{ $t(message) }}
                                </template></v-select>
                            </v-col>
                            <v-col cols="1" md="1" class="d-flex align-center">
                                <v-icon size="17.5" color="orange"
                                    >mdi-keyboard-tab
                                </v-icon>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="6" lg="6">
                        <v-row>
                            <v-col cols="1" md="1"> </v-col>
                            <v-col col="11" md="11">
                                <div class="pa-1 form-label">
                                    {{ $t('message.qualifiedApplicants.academicYearTransfer') }}
                                    <strong>*</strong>
                                </div>
                                <v-select
                                    v-model="selectedAcademicYear"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    :placeholder="`- ${$t('message.qualifiedApplicants.selectAcademic')} -`"
                                    :items="academicYears"
                                    :rules="[
                                        (v) =>
                                            !!v ||
                                            'message.qualifiedApplicants.error.selectStudentFromAcademic',
                                    ]"
                                    required
                                ><template #message="{ message }">
                                    {{ $t(message) }}
                                </template></v-select>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters class="my-5">
                    <v-divider></v-divider>
                </v-row>
                <v-row no-gutters class="pb-7">
                    <v-col cols="12" lg="12" class="d-flex column align-center">
                        <v-avatar
                            color="#255d98"
                            size="27"
                            class="d-flex align-center avatar-shadow"
                        >
                            <span
                                class="white--text prompt-title-page"
                                style="font-size: 18px"
                                >2</span
                            >
                        </v-avatar>
                        <div class="my-1 prompt-title ml-3">
                            {{ $t('message.qualifiedApplicants.stepHeader.two') }}
                        </div>
                    </v-col>
                    <v-col cols="6" lg="6">
                        <v-row>
                            <v-col cols="11" md="11">
                                <div class="pa-1 form-label">
                                    {{ $t('message.qualifiedApplicants.date') }} <strong>*</strong>
                                </div>
                                <v-menu
                                    ref="menu1"
                                    v-model="menu1"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dataDateSlot"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                            dense
                                            outlined
                                            :rules="[
                                                (v) =>
                                                    !!v ||
                                                    'message.qualifiedApplicants.error.fillInitiationDate',
                                            ]"
                                            hide-details="auto"
                                            required
                                            :placeholder="$t('message.qualifiedApplicants.datePlaceholder')"
                                            v-bind="attrs"
                                        ><template #message="{ message }">
                                    {{ $t(message) }}
                                </template></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dataDate"
                                        color="orange"
                                        :locale=locale
                                        width="290"
                                        class="mt-4"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="1" md="1"> </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="6" lg="6" class="mt-8">
                        <v-row>
                            <v-col cols="1" md="1"> </v-col>
                            <v-col cols="11" md="11">
                                <v-btn
                                    class="prompt-"
                                    :disabled="!checkFill"
                                    block
                                    rounded
                                    :color="checkFill ? '#FF9800' : '#AFADB1'"
                                    height="40"
                                    style="
                                        color: white
                                        font-weight: 400;
                                        font-size: 18px;
                                        line-height: 24px;
                                    "
                                    @click="onAccept"
                                >
                                    {{ $t('message.qualifiedApplicants.confirm') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import { formatDateTime } from "@/utils/date";
import * as services from '@/services'
import i18n from "@/i18n";

export default {
    name: "QualifiedForm",
    data: () => ({
        menu1: false,
        selectedAcademicYear: null,
        selectedRegisterForm: null,
        dataDate: "",
        
        rounds: [],
        academicYears: [],
    }),
    computed:{
        locale() {
            return i18n.locale;
        },
        dataDateSlot(){
            if(!this.dataDate) return ""
            return formatDateTime(this.dataDate, this.locale)
        },
        checkFill(){
            if(this.selectedAcademicYear != null && this.selectedRegisterForm != null && this.dataDate != "")
                return true
            return false
        }
    },
    methods: {
        onAccept() {
            // submit form to fetch students
            if (this.$refs?.formQualified?.validate() && this.checkFill) {
                this.$emit("onSelectSection", {
                    registerFormId: this.selectedRegisterForm,
                    semesterYear: this.selectedAcademicYear,
                    startSemesterDate: this.dataDate
                })
            }
        },
        async fetchInitData(){
            try{
                this.loadingUpdate(1)
                const res = await services.getRegisterFormQualify()
                res.data.data.map((item) => {
                    this.rounds.push(item)
                })
                const res2 = await services.getSemesterYear()
                res2.data.data.semester_year.map((item) => {
                    this.academicYears.push(item.year)
                })
            }
            catch(err){
                console.log(err)
            }
            finally{
                this.loadingUpdate(-1)
            }
        },
        loadingUpdate(value){
            this.$emit('loadingUpdate',value)
        }
    },
    mounted(){
        this.fetchInitData()
    }
};
</script>
